/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    BridgeApiFriendOrganisationsV2,
    BridgeApiFriendOrganisationsV2FromJSON,
    BridgeApiFriendOrganisationsV2ToJSON,
} from '../models';

/**
 * 
 */
export class BridgeOrganisationApi extends runtime.BaseAPI {

    /**
     * Get all friend organisations who can can be forwarded
     */
    async getAllForwardableFriendOrganisationsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<BridgeApiFriendOrganisationsV2>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v2/organisations/friends-forwardable`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BridgeApiFriendOrganisationsV2FromJSON(jsonValue));
    }

    /**
     * Get all friend organisations who can can be forwarded
     */
    async getAllForwardableFriendOrganisations(initOverrides?: RequestInit): Promise<BridgeApiFriendOrganisationsV2> {
        const response = await this.getAllForwardableFriendOrganisationsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all friend organisations
     */
    async getAllFriendOrganisationsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<BridgeApiFriendOrganisationsV2>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v2/organisations/friends`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BridgeApiFriendOrganisationsV2FromJSON(jsonValue));
    }

    /**
     * Get all friend organisations
     */
    async getAllFriendOrganisations(initOverrides?: RequestInit): Promise<BridgeApiFriendOrganisationsV2> {
        const response = await this.getAllFriendOrganisationsRaw(initOverrides);
        return await response.value();
    }

}
